// GENERATED from floors.store by tools/floor-store.js — do not edit.
// Edit the store (or the knobs app Floors tab), then re-run the generator.
// The store is the single source of truth; this module is its projection
// the whole codebase imports (the lobby's floor-type select, the server's
// room recipe resolution, the editor's list).
export const FLOORS_DATA = [
  {
    "id": 1,
    "name": "Icy Wasteland",
    "roomNpcs": ["npc-1","goblin-62a0ea","npc-4","npc-3","npc-9","npc-8","npc-13","npc-18","npc-23","npc-27"],
    "bossIds": [3,4,5],
    "roomId": 0,
    "sackTable": 3,
    "guardianRoomPct": 35,
    "puzzleRoomPct": 75,
    "puzzles": [{"kind":"flip-tiles","forceDamage":10},{"kind":"icy-pressure-pads"},{"kind":"chasm-crossing","shimmerIntervalTicks":80,"shimmerDurationTicks":20},{"kind":"orb-wizard","bossId":8}],
  },
  {
    "id": 3,
    "name": "Hell",
    "roomNpcs": ["npc-1","goblin-62a0ea","npc-4","npc-3","npc-9","npc-8","npc-13","npc-18","goblin-ff2600","goblin-613583","npc-5","npc-10","npc-14","npc-19","npc-23","npc-24","npc-27","npc-28"],
    "bossIds": [6,7],
    "roomId": 1,
    "sackTable": 3,
    "guardianRoomPct": 35,
    "puzzleRoomPct": 75,
    "puzzles": [{"kind":"flip-tiles","forceDamage":10},{"kind":"chasm-crossing","shimmerIntervalTicks":80,"shimmerDurationTicks":20},{"kind":"orb-wizard","bossId":8}],
  },
  {
    "id": 4,
    "name": "Death's Domain",
    "roomNpcs": ["npc-1","goblin-62a0ea","npc-4","npc-3","npc-9","npc-8","npc-13","npc-18","goblin-ff2600","goblin-613583","npc-5","npc-10","npc-14","npc-19","goblin-000000","npc-6","npc-11","npc-15","npc-23","npc-24","npc-25","npc-27","npc-28","npc-29"],
    "bossIds": [1,2],
    "roomId": 2,
    "sackTable": 3,
    "guardianRoomPct": 35,
    "puzzleRoomPct": 75,
    "puzzles": [{"kind":"flip-tiles","forceDamage":10},{"kind":"chasm-crossing","shimmerIntervalTicks":80,"shimmerDurationTicks":20},{"kind":"orb-wizard","bossId":8}],
  },
  {
    "id": 5,
    "name": "Den of Blasphemy",
    "roomNpcs": ["npc-1","goblin-62a0ea","npc-4","npc-3","npc-9","npc-8","npc-13","npc-18","goblin-ff2600","goblin-613583","npc-5","npc-10","npc-14","npc-19","goblin-000000","npc-6","npc-11","npc-15","goblin-ffffff","npc-20","npc-16","npc-23","npc-24","npc-25","npc-27","npc-28","npc-29","npc-30"],
    "bossIds": [1,2],
    "roomId": 2,
    "sackTable": 3,
    "guardianRoomPct": 35,
    "puzzleRoomPct": 75,
    "puzzles": [{"kind":"flip-tiles","forceDamage":10},{"kind":"chasm-crossing","shimmerIntervalTicks":80,"shimmerDurationTicks":20},{"kind":"orb-wizard","bossId":8}],
  },
] as const;
